module.exports = __webpack_public_path__ + "static/media/dryer-dark-gray.ce374ebd.svg";